export function Wp7formValidator() {
  const formQuery = '.wpcf7-form';

  /**
   * @type NodeListOf<HTMLFormElement>
   */
  const forms = document.querySelectorAll(formQuery);


  /**
   * @param HTMLFormElement form
   * @returns string[]
   */
  function getRequiredFieldNames(form) {
    const requiredFields = form.querySelectorAll('input[aria-required]');
    const requiredFieldNames = [];
    requiredFields.forEach(field => {
      requiredFieldNames.push(field.name);
    });
    return requiredFieldNames;
  }

  /**
   * @param HTMLFormElement form
   * @param HTMLInputElement input
   */
  function focusedOnce(form, input) {
    const focusedFields = JSON.parse(form.dataset.focusedFields);
    focusedFields[input.name] = true;
    form.dataset.focusedFields = JSON.stringify(focusedFields);
    if (Object.values(focusedFields).every(val => !!val)) {
      addValidationInput(form);
    }
  }

  function addValidationInput(form) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'doswp7-check';
    input.value = 'true';
    form.appendChild(input);
  }

  // for each forms
  forms.forEach(form => {
    const requiredFieldNames = getRequiredFieldNames(form);
    const focusedFields = requiredFieldNames.reduce((prev, curr) => ({...prev, [curr]: false}), {});

    // every field should be focused at least once
    form.dataset.focusedFields = JSON.stringify(focusedFields);
    requiredFieldNames
      .map(fieldName => form.querySelector(`input[name="${fieldName}"]`))
      .forEach(fieldEl => {
        fieldEl.addEventListener('focus', () => focusedOnce(form, fieldEl), {once: true});
      });
  });

}
